import ResourcesModule from './ResourcesModule'

export default ResourcesModule
